import { AppBox, AppButton, AppTypography } from 'components'
import { ProfileModules } from 'globals/constants'
import { FC } from 'react'
import { useAppDispatch } from 'store/app.store'
import { setOpenedProfileModule } from 'store/slices'

interface Props {
  closeDialog: () => void
  openAddUsersDialog: () => void
}

export const ChangePlanConfimation: FC<Props> = ({ closeDialog, openAddUsersDialog }) => {
  const dispatch = useAppDispatch()
  const redirectToOutsideTeam = () => {
    closeDialog()
    dispatch(setOpenedProfileModule(ProfileModules.OutsideTeam))
  }
  return (
    <AppBox>
      <AppTypography fontSize={32} fontWeight={700} textAlign={'center'}>
        Your subscription plan is all set!
      </AppTypography>
      <AppBox paddingX={2} paddingTop={2} display={'flex'} justifyContent={'space-between'} gap={8}>
        <AppBox>
          <AppTypography fontSize={16} fontWeight={'bold'}>
            Two ways to include staff and virtual assistants
          </AppTypography>
          <AppTypography color={'grey.500'} fontSize={14} paddingBottom={1}>
            Did you know we offer two great ways to add people to your workspace?
          </AppTypography>
          <AppTypography color={'grey.500'} fontSize={14}>
            <b>Add Users</b> - By adding users to your subscription plan you can cover everyone within one bill. This
            option is perfect for full-time staff
          </AppTypography>
          <AppBox textAlign={'right'} paddingTop={1}>
            <AppButton variant="contained" color="primary" onClick={openAddUsersDialog}>
              Add Users
            </AppButton>
          </AppBox>
          <AppBox borderTop={1} borderColor={'grey.200'} marginY={2} />
          <AppTypography color={'grey.500'} fontSize={14}>
            <b>Outside Team</b> - When you create an Outside Team you can invite other paid accounts to work within your
            space for no additional cost to you. This is perfect for temporary virtual assistants that may work for
            several companies.
          </AppTypography>
          <AppBox textAlign={'right'} paddingTop={1}>
            <AppButton variant="contained" color="primary" onClick={redirectToOutsideTeam}>
              Outside Team
            </AppButton>
          </AppBox>
        </AppBox>
        <AppBox>
          <img src="/images/pax/Confirmation.png" alt="img" />
        </AppBox>
      </AppBox>
    </AppBox>
  )
}
